<ng-container *ngIf="viewModel$ | async as viewModel; else loading">
    <div *ngIf="viewModel.isLoading">
        <div class="no-records">
            <h2>Loading...</h2>
        </div>
    </div>

    <div *ngIf="!viewModel.isLoading && !viewModel.assets.length">
        <div class="no-records">
            <h2>No Records Found</h2>
        </div>
    </div>

    <table mat-table [dataSource]="viewModel.assets" matSort (matSortChange)="onSort($event)" matSortDisableClear
        [matSortStart]="'asc'" *ngIf="!viewModel.isLoading && viewModel.assets.length">
        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox (change)="$event ? masterToggle() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()">
                </mat-checkbox>
            </th>
            <td class="no-ellipsis" mat-cell *matCellDef="let row">
                <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                    [checked]="selection.isSelected(row)">
                </mat-checkbox>
            </td>
        </ng-container>

        <!--  Image Column -->
        <ng-container matColumnDef="Image">
            <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">
                Preview
            </th>
            <td mat-cell class="offer-image no-ellipsis" *matCellDef="let record">
                <img [src]="record | azureAssetPreview: PreviewMode.Thumbnail" alt="Asset Image"
                    (error)="onImageError($event)">
            </td>
        </ng-container>

        <!-- AssetName Column -->
        <ng-container matColumnDef="AssetName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Name"
                [resizeColumn]="true">
                Asset Name
            </th>
            <td mat-cell *matCellDef="let record"> {{ record.assetName }}</td>
        </ng-container>

        <!-- Group Column -->
        <ng-container matColumnDef="Group">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Group"
                [resizeColumn]="true">
                Group
            </th>
            <td mat-cell *matCellDef="let record">{{ record.assetGroupName }}</td>
        </ng-container>

        <!-- DateAdded Column -->
        <ng-container matColumnDef="DateAdded">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by DateAdded"
                [resizeColumn]="true">
                Date Added
            </th>
            <td mat-cell *matCellDef="let record">{{ record.dateAdded }}</td>
        </ng-container>

        <!-- Type Column -->
        <ng-container matColumnDef="FileType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by FileType"
                [resizeColumn]="true">
                Type
            </th>
            <td mat-cell *matCellDef="let record">{{ record.fileType }}</td>
        </ng-container>

        <!-- File Name Column -->
        <ng-container matColumnDef="FileName">
            <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by FileName" [resizeColumn]="true">
                File Name
            </th>
            <td mat-cell *matCellDef="let record">{{ record.fileName }}</td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="Actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let record; let i = index">
                <button type="button" mat-button color="accent" (click)="onEdit(record, i)">Edit</button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <!-- pager -->
    <mat-paginator [length]="viewModel.totalRecords" [pageSize]="viewModel.searchStateParams.pageSize"
        [pageSizeOptions]="[5, 10, 20, 50, 100, 500]" (page)="onPage($event)"
        *ngIf="!viewModel.isLoading && viewModel.assets.length" showFirstLastButtons
        [pageIndex]="viewModel.searchStateParams.pageIndex">
    </mat-paginator>
</ng-container>

<ng-template #loading>
    <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
</ng-template>